<app-page-meta pageTitle="Finzy - Initiate Payment"></app-page-meta>
<app-header *ngIf="isLodaded()"></app-header>

<div class="container-fluid">
    <div class="row" *ngIf="isLodaded()">
        <ng-container *ngIf="!isPaymentLinkInValid || isLoggedInUser()">
            <div class="col-xs-12 col-md-12 col-lg-12">
                <div class="payment-amount-cont col-sm-4 bg-grey">
                    <div class="row">
                        <p class="wallet-breadcrumb col-sm-8 col-sm-offset-1"><a class="bread"
                                [routerLink]="[paymentInitiator?.link]">
                                {{ paymentInitiator?.linkLabel }}</a>
                            <ng-container *ngIf="paymentInitiator?.userType === 'Lender'">
                                &nbsp;/Payment
                            </ng-container>
                        </p>
                    </div>
                    <div class="row">
                        <p class="add-money-header col-sm-11 col-sm-offset-1">{{ paymentInitiator?.label }}</p>
                    </div>
                    <div class="row col-sm-offset-1">
                        <span class="amount-label">Amount:</span>
                        <mat-form-field class="amount-input">
                            <span matPrefix class="rupee-symbol">₹&nbsp;</span>
                            <input matInput class="topup-amount-input" [disabled]="disableAmountField" [(ngModel)]="paymentCollectionRequest.amount"
                                name="topupAmount" type="number" onKeyPress="if(this.value.length==10) return false;">

                        </mat-form-field>
                    </div>
                    <div class="row error-message">
                        <span class="finzy-red" *ngIf="paymentCollectionRequest.amount <= 0">Please enter the valid
                            amount</span>
                    </div>
                </div>

                <div class="col-sm-6 col-sm-offset-1">
                    <div class="row">
                        <p class="payment-mode-header">Select Payment Mode</p>
                    </div>
                    <div class="row">
                        <div class="payment-mode-details">
                            <app-payment-mode (currentFormInstanceChange)="onTabChanged($event)"
                                [paymentRequest]="paymentCollectionRequest"></app-payment-mode>
                        </div>
                    </div>
                    <div class="row">
                        <div class="button-cont">
                            <button class="cancel-payment-btn" (click)="cancelPayment()">CANCEL PAYMENT</button>

                            <button *ngIf="dataLoader === false" class="continue-button"
                                (click)="pay()">CONTINUE</button>
                            <div *ngIf="dataLoader === true" class="loader">
                                <mat-spinner [diameter]="35"></mat-spinner>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="isPaymentLinkInValid">
            <div class="col-xs-12 col-md-12 col-lg-12 mt-4">
                <app-payment-failure-template [rowOne]="rowOne" [templateButtonText]="templateButtonText" [showTemplateButton]="showTemplateButton"></app-payment-failure-template>
            </div>
        </ng-container>
    </div>
    <ng-container *ngIf="!isLodaded()">
        <div class="loader_main">
            <svg class="circular" viewBox="25 25 50 50">
              <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
            </svg>
          </div>
    </ng-container>
    <template #paymentContainer></template>
</div>
<app-footer></app-footer>